import React from 'react';
import { EntityForm } from '../widgets/Forms';
import ViewUtils from '../ViewUtils';
import ProjectDocumentDialog from "./ProjectDocumentDialog";

const utils = new ViewUtils();
export const ProjectUploadForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [documentsDialogOpen, setdocumentsDialogOpen] = React.useState(false);
    const [projectFileName, setProjectFileName] = React.useState('');

    const postUploadHandler = (save, cancel) => {
        if (save === true) {
            setdocumentsDialogOpen(false);
        }
        else if (cancel === true) {
            setdocumentsDialogOpen(false);
        }
        else {
            setdocumentsDialogOpen(false);
        }
    };

    return (
        <EntityForm ref={ref} viewId="ProjectUploadForm" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            dataURL={utils.isNull(props.dataURL) ? "" : props.dataURL}
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="ProjectUploadForm">
                    <table cellPadding="2" width="80%">
                        <tbody>
                            <tr>
                                <td >
                                    <div>
                                        <ProjectDocumentDialog
                                            open={documentsDialogOpen}
                                            closeHandler={(save, cancel) => postUploadHandler(save, cancel)}
                                            postUrl="api/sims/projectupload/AddProjectDocument"
                                            EntityID={props.id}
                                            buttonLabel={"Upload Document"}
                                            fileName={projectFileName}
                                            _setFilename={(name) => { setProjectFileName(name) }}
                                        />
                                    </div>
                                </td>
                                <br></br>
                                <br></br>
                            </tr>
                        </tbody>
                    </table>
                </form>
            }
        </EntityForm>
    );
})
